import { ABNORMAL_ORGAN_VOLUME_CONDITION, DEGENERATIVE_CHANGE_CONDITION } from '@/shared/constant';

export const EXCLUDED_PRIOR_SCAN_COMPARISON_CONDITIONS: string[] = [
  ABNORMAL_ORGAN_VOLUME_CONDITION,
  DEGENERATIVE_CHANGE_CONDITION,
];
